export default "__VITE_ASSET__7686fbb5__"